import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExgTabV2ComponentHeaderElement} from '../../misc/exg-tab-v2/exg-tab-v2.component';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-organization-unit-box',
  templateUrl: './modal-organization-unit-box.component.html',
  styles: []
})
export class ModalOrganizationUnitBoxComponent extends ExcTranslation implements OnInit {

  _data: any;
  @Input()
  set data(value: any) {
    this._data = value;
    this.initialize();
  }

  get data(): any {
    return this._data;
  }

  contacts: any = {};
  addresses: any = {};

  tabs: ExgTabV2ComponentHeaderElement[] = [];

  constructor(private modal: ExgModalService, public enumSvc: EnumerationService) {
    super();
    const SELF = this;
    this.tabs = [
      {
        get caption(): string {
          return SELF.getGlobal('Contacts');
        },
        get icon_class(): string {
          return SELF.getTranslation('Icons.Contact');
        }
      },
      {
        get caption(): string {
          return SELF.getGlobal('Addresses');
        },
        get icon_class(): string {
          return SELF.getTranslation('Icons.Address');
        }
      }
    ];
  }

  ngOnInit(): void {
  }

  initialize(): void {
    if (this.data) {
      for (const cont of this.data.contacts) {
        if (!this.contacts[cont.kont_enmIdent_KontaktTyp as number]) {
          this.contacts[cont.kont_enmIdent_KontaktTyp] = [];
        }
        this.contacts[cont.kont_enmIdent_KontaktTyp].push(cont);
      }
      for (const adr of this.data.addresses) {
        if (!this.addresses[adr.adr_enmIdent_AdresseTyp]) {
          this.addresses[adr.adr_enmIdent_AdresseTyp] = [];
        }
        this.addresses[adr.adr_enmIdent_AdresseTyp].push(adr);
      }
    }
  }

  clickedOkay(): void {
    this.modal.close();
  }

  getNumber(input: any): number {
    return input as number;
  }

  getArray(input: any): any[] {
    return input as any[];
  }
}
